//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {fetchCommissionHrReport} from "@/api/report";
import func from "@/utils/decoded";
import {Message} from "element-ui";
import {fetchCommissionHR} from "@/api/commission";
import {fetchFilter} from "@/api/master";
import moment from "moment/moment";

const fields = [
	{key: 'contract_id', label: 'เลขที่สัญญา', _style: 'min-width:100px'},
	{key: 'name_customer', label: 'ชื่อ-สกุล', _style: 'min-width:150px;'},
	{key: 'vehicle_number', label: 'ทะเบียนรถ', _style: 'min-width:50px;'},
	{key: 'startDate', label: 'วันที่เริ่มทำสัญญา', _style: 'min-width:100px;'},
	// { key: 'balance', label:'ยอดเงินคงเหลือ', _style:'min-width:100px; text-align: right;' },
	// { key: 'status', label:'สถานะ', _style:'min-width:100px;' },
	{key: 'process_day', label: 'เวลาดำเนินการ(วัน)', _style: 'min-width:50px; text-align: right;'},
	{key: 'commission', label: 'ค่าคอมมิชชั่น', _style: 'min-width:100px;'},
	{
		key: 'show_details',
		label: 'รายละเอียด',
		_style: 'min-width:150px; text-align: center;',
		sorter: false,
		filter: false
	}
]

export default {
	name: 'Commission',
	data() {
		return {
			options: [],
			show: true,
			isCollapsed: true,
			items: [],
			fields,
			filterParams: {
				stepId: 1
			},
			searchParams: {
				keyword: '',
				startDate: '',
				endDate: '',
				filter: 0
			},
			privilege: {read: false, write: false, report: false}
		}
	},
	watch: {
		$route: {
			immediate: true,
			handler(route) {
				if (route.query && route.query.page) {
					this.activePage = Number(route.query.page)
				}
			}
		}
	},
	async mounted() {
		this.$store.state.loading = true
		try {
			this.searchParams.endDate = moment().format('YYYY-MM-DD')
			this.searchParams.startDate = moment().subtract(6, 'months').format('YYYY-MM-DD')
			await new Promise((resolve, reject) => {
				fetchFilter(this.filterParams).then(response => {
					const check = response.header
					const data = response.body
					if (check.error === 'N') {
						this.options = data
						resolve()
					}
				}).catch(error => {
					this.errorMsg = error
					console.log(error)
					reject(error)
				})
			})
			await this.getCommissionList()
		} finally {
			this.$store.state.loading = false
		}

		const check = func.checkMenu(this.$route.path)
		if (check && check.length > 0) {
			this.privilege = check[0]
		}
	},
	methods: {
		async getCommissionList() {
			console.log('searchParams : ', this.searchParams);
			this.$store.state.loading = true
			await fetchCommissionHR(this.searchParams).then(res => {
				this.items = []
				const check = res.header;
				const data = res.body;
				if (check.error === 'N') {
					if (data) {
						for (let item of data) {
							if (item.status_id === 1) {
								item.commission = 'รอดำเนินการ'
							} else {
								item.commission = item.total_commission
							}
						}
						this.items = data;
					}
				}
			}).catch(error => {
				Message({
					message: 'มีข้อผิดพลาด กรุณาติดต่อผู้ดูแลระบบ',
					type: 'error',
					duration: 5 * 1000,
				})
				this.errorMsg = error
				console.log(error)
			})
			this.$store.state.loading = false
		},
		handleCommissionExport() {
			const loading = this.$loading({
				lock: true,
				text: 'Please wait',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			})

			fetchCommissionHrReport(this.searchParams).then(response => {
				const fileURL = window.URL.createObjectURL(new Blob([response]))
				const fileName = 'Commission_' + func.generateReportDate() + '.xlsx'
				const link = document.createElement('a')

				link.href = fileURL
				link.setAttribute('download', fileName)
				document.body.appendChild(link)
				loading.close()
				if (response.size > 0 && response.type !== 'application/json') {
					link.click()
				} else {
					this.$notify({
						title: 'Error',
						message: 'ไม่สามารถสร้างรายงานคอมมิชชั่นได้',
						type: 'error',
						duration: 5000
					})
				}
				link.remove()

				// Just to simulate the time of the request
				setTimeout(() => {
					loading.close()
				}, 1.5 * 1000)
			})
		},
		getBadge(status) {
			switch (status) {
				case 'รอดำเนินการ':
					return 'warning'
				default:
					return 'primary'
			}
		},
		rowClickDetail(item) {
			this.$router.push({path: `/stepHR/CommissionDetail/${item.contract_id}`})
		},
		pageChange(val) {
			console.log(val);
			this.$router.push({query: {page: val}})
		}
	}
}
